import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useEditVideoMutation,
  useGetVideoQuery,
} from "../../features/videos/videosApi";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import styles from "./videoForm.module.css";

export default function VideoEditForm() {
  const { videoId } = useParams();
  const navigate = useNavigate();
  const titleRef = useRef();
  const descRef = useRef();
  const urlRef = useRef();
  const viewsRef = useRef();
  const durationRef = useRef();
  const createdAtRef = useRef();
  const {
    data: video,
    isSuccess,
    isLoading,
    error,
    isError,
  } = useGetVideoQuery(videoId, {
    refetchOnMountOrArgChange: true,
  });
  const [editVideo, { isSuccess: isEditSuccess }] = useEditVideoMutation();

  const handleEdit = (e) => {
    e.preventDefault();
    const data = {
      title: titleRef?.current.value,
      description: descRef?.current.value,
      url: urlRef?.current.value,
      views: viewsRef?.current.value,
      duration: durationRef?.current.value,
      createdAt: createdAtRef?.current.value,
    };

    editVideo({ id: video?.id, data });
  };

  useEffect(() => {
    if (isSuccess && titleRef?.current) {
      const date = new Date(video?.createdAt);
      const dateString = date?.toISOString().substring(0, 10);
      // set the value of all the inputs
      titleRef.current.value = video?.title;
      descRef.current.value = video?.description;
      urlRef.current.value = video?.url;
      viewsRef.current.value = video?.views;
      durationRef.current.value = video?.duration;
      createdAtRef.current.value = dateString;
    }

    if (isEditSuccess) {
      navigate("/admin/videos");
    }
  });

  // decide what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && video?.id) {
    content = (
      <form
        onSubmit={handleEdit}
        className={`${styles.videoForm}  bg-primary border border-slate-50/10 `}
      >
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="titleInput">Title</label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="titleInput"
            ref={titleRef}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="descriptionInput">Description</label>
          <textarea
            rows={5}
            className="bg-slate-900 p-2 "
            type="text"
            id="descriptionInput"
            ref={descRef}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="urlInput">url</label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="urlInput"
            ref={urlRef}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="viewsInput">views</label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="viewsInput"
            ref={viewsRef}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="durationInput">duration</label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="durationInput"
            ref={durationRef}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="createdAtInput">createdAt</label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="date"
            id="createdAtInput"
            ref={createdAtRef}
          />
        </div>
        <button
          type="submit"
          className="block ml-auto bg-violet-600 p-2 px-4 rounded-md text-white"
        >
          Save
        </button>
      </form>
    );
  }

  return (
    <>
      <div className="justify-center mb-10 space-y-2 flex md:space-y-0">
        {content}
      </div>
    </>
  );
}
